<template>
  <v-snackbar
    v-model="$store.state.snackbar.show"
    :color="$store.state.snackbar.color"
    top
  >
    {{ $store.state.snackbar.text }}
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
